import {
  GET_PAYMENT_METHODS_REQUEST,
  GET_PAYMENT_METHODS_SUCCESS,
  GET_PAYMENT_METHODS_FAILURE,
  SHOW_PAYMENT_METHOD_FORM,
  HIDE_PAYMENT_METHOD_FORM,
  CREATE_PAYMENT_METHOD_REQUEST,
  CREATE_PAYMENT_METHOD_SUCCESS,
  CREATE_PAYMENT_METHOD_FAILURE,
  SET_DEFAULT_PAYMENT_METHOD_REQUEST,
  SET_DEFAULT_PAYMENT_METHOD_SUCCESS,
  SET_DEFAULT_PAYMENT_METHOD_FAILURE,
  SHOW_CONFIRM_DELETE_PAYMENT_METHOD,
  HIDE_CONFIRM_DELETE_PAYMENT_METHOD,
  DELETE_PAYMENT_METHOD_REQUEST,
  DELETE_PAYMENT_METHOD_SUCCESS,
  DELETE_PAYMENT_METHOD_FAILURE,
} from './paymentMethodsTypes';

export default function(
  state = {
    requestingGetPaymentMethods: false,
    requestingCreatePaymentMethod: false,
    requestingSetDefaultPaymentMethod: false,
    paymentMethods: null,
    paymentMethodFormIsVisible: false,
    confirmDeletePaymentMethodIsVisible: false,
  },
  action
) {
  switch (action.type) {
    case GET_PAYMENT_METHODS_REQUEST:
      return {
        ...state,
        requestingGetPaymentMethods: true,
      };
    case GET_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        paymentMethods: action.response.data,
        requestingGetPaymentMethods: false,
      };
    case GET_PAYMENT_METHODS_FAILURE:
      return {
        ...state,
        requestingGetPaymentMethods: false,
      };
    case SHOW_PAYMENT_METHOD_FORM:
      return {
        ...state,
        paymentMethodFormIsVisible: true,
        noDialogBackground: action.noDialogBackground,
      };
    case HIDE_PAYMENT_METHOD_FORM:
      return {
        ...state,
        paymentMethodFormIsVisible: false,
      };
    case CREATE_PAYMENT_METHOD_REQUEST:
      return {
        ...state,
        requestingCreatePaymentMethod: true,
      };
    case CREATE_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        requestingCreatePaymentMethod: false,
        paymentMethodFormIsVisible: false,
        paymentMethods: action.response.data,
      };
    case CREATE_PAYMENT_METHOD_FAILURE:
      return {
        ...state,
        requestingCreatePaymentMethod: false,
      };
    case SET_DEFAULT_PAYMENT_METHOD_REQUEST:
      return {
        ...state,
        requestingSetDefaultPaymentMethod: true,
      };
    case SET_DEFAULT_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        requestingSetDefaultPaymentMethod: false,
        paymentMethods: state.paymentMethods.map(paymentMethod => ({
          ...paymentMethod,
          is_preferred: paymentMethod.id === action.cardId,
        })),
      };
    case SET_DEFAULT_PAYMENT_METHOD_FAILURE:
      return {
        ...state,
        requestingSetDefaultPaymentMethod: false,
      };
    case SHOW_CONFIRM_DELETE_PAYMENT_METHOD:
      return {
        ...state,
        confirmDeletePaymentMethodIsVisible: true,
      };
    case HIDE_CONFIRM_DELETE_PAYMENT_METHOD:
      return {
        ...state,
        confirmDeletePaymentMethodIsVisible: false,
      };
    case DELETE_PAYMENT_METHOD_REQUEST:
      return {
        ...state,
        requestingDeletePaymentMethod: true,
      };
    case DELETE_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        requestingDeletePaymentMethod: false,
        confirmDeletePaymentMethodIsVisible: false,
      };
    case DELETE_PAYMENT_METHOD_FAILURE:
      return {
        ...state,
        requestingDeletePaymentMethod: false,
      };
    default:
      return state;
  }
}
